import { Component, Input, OnInit } from '@angular/core';
import { FileService } from '@services/lm/file.service';

interface AvatarInfo {
    avatar?: string;
    firstName?: string;
    lastName?: string;
    name?: string;
    label?: string;
    email?: string;
}

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrl: './avatar.component.less'
})
export class AvatarComponent implements OnInit {
    @Input() enable: boolean = true;
    @Input() info: AvatarInfo | undefined;
    @Input() size = 34;
    @Input() showTooltip = false;
    bgColor = '';
    colorArr: {
        [key: string]: string
    } = {
        A: '#125082',
        B: '#3a0e72',
        C: '#640646',
        D: '#095417',
        E: '#544609',
        F: '#366d1b',
        G: '#BD5FFC',
        H: '#FC5F77',
        I: '#23f7ee',
        J: '#0A6D3A',
        K: '#6B2EAD',
        L: '#DA2F15',
        M: '#80aa65',
        N: '#AAFF56',
        O: '#6c4d63',
        P: '#FFDEAD',
        Q: '#c7ed98',
        R: '#8AC153',
        S: '#214c9c',
        T: '#8893b8',
        U: '#216ae3',
        V: '#e9d2ca',
        W: '#bbc730',
        X: '#473C9D',
        Y: '#e0aff7',
        Z: '#007B52',
    };

    constructor(private fileService: FileService) {
    }

    ngOnInit(): void {
        const firstCode = this.userName.slice(0, 1).toUpperCase();
        this.bgColor = this.colorArr[firstCode];
    }

    get userName(): string {
        const firstName = this.info?.firstName;
        const lastName = this.info?.lastName;
        return this.info?.name ? this.info.name : (firstName ? firstName : '') + ' ' + (lastName ? lastName : '');
    }

    get avatarImage(): string {
        const avatar = this.info?.avatar;
        if (!avatar || avatar.startsWith('http')) {
            return avatar || '';
        }
        return this.fileService.getPath(avatar);
    }

    get label(): string {
        const name = this.info?.name?.includes(' ') ? this.info?.name : `${this.info?.name} ${this.info?.lastName}`;
        return  `${name} (${this.info!.email})`;
    }

}
